<template>
    <action v-if="group.has_saml_mapping">
        <template slot="header">SAML Merkmale Matrix</template>

        <saml-attribute-repeater
            class="grid grid-cols-3 gap-1 repeater-item"
            v-model="officeMapping"
            :inputs="officeMappingConfig"
        />

        <saml-attribute-repeater
            class="grid grid-cols-3 gap-1 repeater-item"
            v-model="departmentMapping"
            :inputs="departmentMappingConfig"
         />

        <template slot="action">
            <button-primary @click="submit">
                <template slot="icon"><i class="fa fa-save"></i></template> Speichern
            </button-primary>
        </template>
    </action>
</template>

<script>
import Action from "../UI/Action";
import ButtonPrimary from "../UI/ButtonPrimary";
import InputText from "../UI/InputText";
import SamlAttributeRepeater from "../UI/SamlAttributeRepeater.vue";

export default {
    name: "SamlMapping",
    components: {SamlAttributeRepeater, InputText, ButtonPrimary, Action},
    inject: ['group'],

    data: () => ({
        code: '',
        departmentMapping: [],
        departmentMappingConfig: [],
        officeMapping: [],
        officeMappingConfig: [],
    }),

    created() {
        this.departmentMapping = this.group.saml_mapping?.user_groups?.map(item => ({
            department: item.department,
            user_groups: item.user_groups,
            disabled: item.disabled ?? false,
        }));

        this.officeMapping = this.group.saml_mapping?.associated_groups?.map(item => ({
            office: item.office,
            group_id: item.group_id,
            department: item.department ?? '',
            disabled: item.disabled ?? false,
            ignore_departments: item.ignore_departments ?? false,
        }));

        this.departmentMappingConfig = [
            {
                key: "department",
                type: "text",
                label: "Department",
                placeholder: "SAML Department",
            },
            {
                key: "user_groups",
                type: "tags",
                label: "Benutzergruppen",
                placeholder: "Benutzergruppen",
            },
        ];

        this.officeMappingConfig = [
            {
                key: "office",
                type: "text",
                label: "Office",
                placeholder: "SAML Office",
            },
            {
                key: "group_id",
                type: "select",
                label: "zugehörige Gruppe",
                placeholder: "Gruppe auswählen",
                selectOptions: [
                    ... this.group.associated_groups.map(item => ({
                        value: item.id,
                        text: item.name
                    }))
                ]
            },
            {
                key: "department",
                type: "text",
                label: "Department",
                placeholder: "Standard Department",
            },
            {
                key: "ignore_departments",
                type: "select",
                label: "Departments ignorieren",
                selectOptions: [
                    {value: 0, text:'Nein'},
                    {value:1, text: 'Ja'},
                ]
            },
        ]
    },

    methods: {
        submit() {
            window.axios.post(`/admin/group`, {
                saml_mapping: {
                    department_mapping: this.departmentMapping,
                    office_mapping: this.officeMapping
                },
            })
                .then((response) => {
                    location.reload();
                })
                .catch((error) => {
                    this.$root.$emit('error', error);
                });
        },
    }
}
</script>

<style scoped>

</style>
